<template>
  <div class="footer">
    <div class="container">
      <div class="box">
        <div class="left-box">
          <div class="company">
            <p class="title">Our Company</p>
            <a href="http://en.genemind.com/" target="blank">
              <img src="../assets/img/tou-logo.png" alt="logo" />
            </a>
          </div>
          <div class="fWAlgae">
            <p class="title">FWAlgaeDB</p>
            <p>Freshwater algae genomic and annotation information</p>
          </div>
          <div class="partners">
            <p class="title">Our Partners</p>
            <p style="margin-bottom:15px">
              Shenzhen Academy of Environmental Sciences
            </p>
            <p>
              State Environmental Protection Key Laboratory of Drinking Water
              Source Management and Technology
            </p>
          </div>
          <div class="database">
            <p class="title">Public Database</p>
            <p>
              <a href="http://algae.ihb.ac.cn/english/" target="blank"
                >FACHB-collection</a
              >
            </p>
            <p>
              <a href="https://www.algaebase.org/" target="blank">AlgaeBase</a>
            </p>
            <p>
              <a href="https://www.algaehub.cn/#/home_page" target="blank"
                >Algae-Hub</a
              >
            </p>
            <p>
              <a href="https://www.diatombase.org/" target="blank"
                >DiatomBase</a
              >
            </p>
          </div>
        </div>
        <div class="contact">
          <p class="title">Contact Details</p>
          <p>
            Address: 5F and 6F, Block 2, Luohu Investment Holding Building, No.
            116, Qingshuihe 1st Road, Luohu District, Shenzhen, Guangdong, China
          </p>
          <p>E-mail: info@genemind.com</p>
          <p>Tel: +86-400-822-3660</p>
        </div>
      </div>
    </div>
    <div class="copy-right">
      <span>
        Copyright © 2022 GeneMind All Rights Reserved.
        <a href="https://beian.miit.gov.cn/" target="blank"
              >Guangdong ICP 14041200-4</a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Afooter'
}
</script>

<style lang="scss" scoped>
.footer {
  min-width: vw(1200);
  height: vw(520);
  background: $theme_color;
  color: #ffffff;
  position: relative;

  .container {
    margin: 0 auto;
    padding-top: vw(45);
    width: vw(1200);

    .box {
      display: flex;
      font-size: vw(18);
      line-height: 1.5;
      width: vw(1200);

      .left-box {
        display: flex;
        flex-wrap: wrap;
        width: vw(900);

        div {
          width: vw(300);
          height: vw(180);
          margin-right: vw(100);

          a {
            color: #fff;
            line-height: vw(32);
            img {
              width: vw(186);
              height: vw(43);
            }
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
      .contact {
        width: vw(420);
        p {
          &:not(:first-child) {
            margin-bottom: vw(20);
          }
        }
      }
      .title {
        font-size: vw(24);
        margin-bottom: vw(40);
        position: relative;
        display: inline-block;
        &::after {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          bottom: vw(-10);
          width: 100%;
          height: 2px;
          background-color: #fff;
        }
      }
    }
  }
  .copy-right {
    position: absolute;
    bottom: 0;
    font-size: vw(13);
    width: 100%;
    text-align: center;
    a {
      color: #fff;
      line-height: vw(15);
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/afooter.vue